import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { AnimationService } from 'src/app/services/animation/animation.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AboutUsComponent implements OnInit, AfterViewInit {
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;

  aboutShowcaseCards = [
    {
      title: 'What It Will Take',
      subtitle: '',
      textPosition: {
        top: '21.18%',
        right: '56.69%',
        bottom: '48.81%',
        left: '8.28%',
      },
      titleRight: '56.76%',
      gradient:
        'linear-gradient(110deg, rgba(0, 0, 0, 0.78) 0%, rgba(0, 0, 0, 0.35) 55%, rgba(0, 0, 0, 0.1) 100%)',
      paragraphs: [
        'Building modern, first-world cities in Africa requires vision, but it also demands structure, an enabling environment for investment, and strong reasons for our people and the world to believe in the future we are creating.',
        'By discovering what makes each African community unique and showcasing it through smart property projects and unique hospitality experiences, we create real value that draws people, resources, and investment to transform our communities and improve lives.',
      ],
      image: '/assets/imgs/about-slider-1.jpg',
    },
    {
      title: 'The Model',
      subtitle: '',
      textPosition: {
        top: '21.18%',
        right: '8.28%',
        bottom: '48.81%',
        left: '56.69%',
      },
      titleRight: '0%',
      gradient:
        'linear-gradient(270deg, rgba(0, 0, 0, 0.82) 0%, rgba(0, 0, 0, 0.45) 50%, rgba(0, 0, 0, 0.1) 100%)',
      paragraphs: [
        'Every great destination builds its strengths to create value, giving people a reason to visit, invest, and belong.',
        'We begin by identifying what makes each place unique, then design projects that bring its character to life through architecture, hospitality, and lifestyle. Each development is built to meet and exceed global standards, designed for long-term impact, and open to both local and international participation.',
        'Our model transforms how African cities grow by showing the world why they are unique and valuable, starting with Benin City.',
      ],
      image: '/assets/imgs/about-slider-2.jpg',
    },
    {
      title: 'Benin City',
      subtitle: 'Where Our Vision Begins',
      textPosition: {
        top: '7.36%',
        right: '40.04%',
        bottom: '56.63%',
        left: '8.5%',
      },
      titleRight: '56.76%',
      gradient:
        'linear-gradient(115deg, rgba(0, 0, 0, 0.7) 10%, rgba(0, 0, 0, 0.35) 55%, rgba(0, 0, 0, 0.1) 100%)',
      paragraphs: [
        'Benin City has always been a free and welcoming place, where people from different backgrounds come to live, trade, and create. For centuries, it has embraced newcomers who became part of its story, shaping a city known for creativity, hospitality, and cultural richness.',
        'Located in Edo State, which covers about 17,802 square kilometers and holds one of the largest undeveloped land areas in southern Nigeria, Benin City offers both the space and flexibility for urban expansion. With a population of over 1.7 million, the city connects key regions across southern Nigeria, linking major markets like Lagos and Abuja with emerging ones in the South-South and Southeast.',
        'This strategic position gives investors access to trade routes, skilled labor, and a fast-growing consumer market. Benin City is ready for investment, offering both the heritage and human capital required to support its transformation.',
        'Our goal for Benin City is to bring development and position it as the ultimate destination for hospitality and entertainment.',
        "By building to meet and surpass global standards while preserving its culture of freedom, a culture that allows every man and woman to express themselves, celebrate their identity, and experience life beyond the ordinary, we are positioning Benin City as Africa's next destination for hospitality, entertainment, and lifestyle. A city ready to welcome the world once again.",
      ],
      image: '/assets/imgs/about-slider-3.jpg',
    },
  ];

  constructor(private animate: AnimationService) {}

  ngOnInit(): void {
    // Bootstrap carousel is initialized automatically via data-bs-ride="carousel"
  }

  isShown: boolean = false;
  beninCityExpanded: boolean = false;

  ngAfterViewInit(): void {
    const elements = this.textContent.toArray().map((el) => el.nativeElement);

    if (elements) {
      this.animate.fadeInElementsImmediate(elements, 0.05);
    }
  }

  readText() {
    this.isShown = !this.isShown;
  }

  toggleBeninCityText() {
    this.beninCityExpanded = !this.beninCityExpanded;
  }

  getBeninCityParagraphs(): string[] {
    const beninCityCard = this.aboutShowcaseCards[2];
    if (!beninCityCard) return [];

    if (this.beninCityExpanded) {
      return beninCityCard.paragraphs;
    }

    // Show half of the paragraphs (rounded down)
    const halfIndex = Math.floor(beninCityCard.paragraphs.length / 2);
    return beninCityCard.paragraphs.slice(0, halfIndex);
  }
}
